'use client';

export { useMonocle } from '@spur.us/monocle-react';
